import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Auth from "./components/Auth";
import Shell from "./views/Shell";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      component: Shell,
      children: [
        {
          path: "",
          name: "home",
          component: Home,
        },
        {
          path: "settings",
          name: "settings",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Settings.vue")
        }
      ]
    },
    {
      path: "/auth",
      name: "auth",
      component: Auth
    }
  ]
});
